import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';

import { 
  checkPassword, clearCheckPassword, fetchBaseUsers, fetchUserDetail, fetchGroups,
  fetchGroupDetail, fetchPermissions, editUserDetail, createUserDetail, resetPassword,
  resetUserDetail, fetchWarehouseWithCompanyId,
} from '../../actions/settings_actions';

import { 
  fetchActiveCustomers
} from '../../actions/customers_actions';

import UserManagementDetail from '../../components/Settings/userManagementDetail';

const validate = values => {
  const errors = {}
  if ( values.password && values.passwordConfirm && values.password != values.passwordConfirm) {
      errors.password = 'password does not match!'
  }
  if (!values.Warehouse_id || values.Warehouse_id.length == 0) {
    errors.Warehouse_id = 'Warehouse requried'
  }
  if (!values.Company_id || values.Company_id.length == 0) {
    errors.Company_id = 'Company requried'
  }
  return errors;
}

let userManagementDetail = reduxForm({
    form: 'userManagementDetail',
    validate,
    enableReinitialize: true,
    touchOnChange: true,
    touchOnBlur: false,
})(UserManagementDetail);
function mapStateToProps(state) {
    const companyOptions = state.header.companies.map(company => ({ label: company.Name, value: company.id }));
    const warehouseOptions = state.settings.warehouses.map(warehouse => ({ label: warehouse.Name, value: warehouse.id }))
    return {
        currentUser: state.settings.currentUser,
        userDetail: state.settings.userDetail,
        isLoading: state.settings.userDetailIsLoading,
        error: state.settings.userDetailError,
        initialValues: state.settings.userDetail,
        groups: state.settings.groups,
        groupsError: state.settings.groupsError,
        groupsIsLoading: state.settings.groupsIsLoading,
        groupDetail: state.settings.groupDetail,
        groupDetailIsLoading: state.settings.groupDetailIsLoading,
        groupDetailError: state.settings.groupDetailError,
        permissions: state.settings.permissions,
        permissionsIsLoading: state.settings.permissionsIsLoading,
        permissionsError: state.settings.permissionsError,
        createUserDetailError: state.settings.createUserDetailError,
        userPermissions: state.auth.userPermissions,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
        customers: state.customers.all,
        companyOptions,
        warehouseOptions,
    };
}

export default connect(mapStateToProps, { 
    checkPassword, clearCheckPassword, fetchBaseUsers, fetchUserDetail, fetchGroups,
    fetchGroupDetail, fetchPermissions, editUserDetail, createUserDetail,
    resetPassword, resetUserDetail, fetchWarehouseWithCompanyId, fetchActiveCustomers,
    changeFieldValue: (field, value) => dispatch => dispatch(change(`userManagementDetail`, field, value)),
 })(userManagementDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/userManagementDetail.jsx